// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "PageTabs-module--bx--text-truncate--end--OC59x";
export var bxTextTruncateFront = "PageTabs-module--bx--text-truncate--front--5I6-L";
export var tabsContainer = "PageTabs-module--tabs-container--Cdfzw";
export var list = "PageTabs-module--list--xLqxG";
export var listItem = "PageTabs-module--list-item--024o6";
export var link = "PageTabs-module--link--Kz-7R";
export var selectedItem = "PageTabs-module--selected-item--aBB0K";